"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Enables HMR if available and triggers given callback
 * on hot reloads.
 */
exports.default = function (s, cb, hot) {
  if (module.hot) {
    hot(function (m) {
      return cb(m, true);
    });
  }

  cb(s);
};